import { baseQuery } from "src/store/helpers/baseQuery";
import { keepUnusedDataFor } from "src/store/helpers/cacheLifetime";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient from "./rtkClient";

export const fdroidsApi = createApi({
    reducerPath: "fdroidsApi",
    tagTypes: ["Fdroids"],
    keepUnusedDataFor,
    baseQuery,
    endpoints: (builder) => ({
        createFdroid: rtkClient.createFdroid(builder),
        deleteFdroid: rtkClient.deleteFdroid(builder),
        deleteFdroidRepo: rtkClient.deleteFdroidRepo(builder),
        getFdroids: rtkClient.getFdroids(builder),
    }),
});

export const { useCreateFdroidMutation, useDeleteFdroidMutation, useDeleteFdroidRepoMutation, useGetFdroidsQuery, usePrefetch } =
    fdroidsApi;
